module.exports = __webpack_public_path__ + "static/media/lena5.34e9b485.jpg";